import { useCallback, useEffect } from 'react';
import { isInteractiveElement } from '@bynder-studio/misc';
import { isCtrlKey } from 'packages/helpers/hotKeys';
import { useIsModalOpen } from 'packages/hooks/useIsModalOpen';

const usePresetShortcuts = ({ toggleModal, createPreset }: { toggleModal?: () => void; createPreset?: () => void }) => {
    const isModalOpen = useIsModalOpen();

    const handleKeyDown = useCallback(
        (e: KeyboardEvent): void => {
            if (isInteractiveElement(e) || e.shiftKey || isModalOpen) {
                return;
            }

            if (!isCtrlKey(e)) {
                switch (e.code) {
                    case 'KeyP': {
                        if (toggleModal) {
                            toggleModal();
                        }

                        break;
                    }

                    default:
                        break;
                }
            } else {
                switch (e.code) {
                    case 'KeyP': {
                        e.preventDefault();

                        if (createPreset) {
                            createPreset();
                        }

                        break;
                    }

                    default:
                        break;
                }
            }
        },
        [toggleModal, createPreset, isModalOpen],
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
};

export default usePresetShortcuts;
